"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgWithdraw = function SvgWithdraw(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 18"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.72 11.115c.06.808.097 1.316.111 1.524.087 1.148-.565 2.024-1.958 2.627-2.088.905-7.966 2.274-16.076.397-1.902-.297-2.746-1.46-2.617-2.528.086-.712.16-1.4.225-2.067.164-.834.764-1.175 1.8-1.024 1.555.228 1.037.177 2.284.387 1.247.21 1.13.32 1.74 1.68.609 1.36.282 1.717 2.177 1.728 1.263.007 2.933-.037 5.01-.132.735.01 1.172-.441 1.309-1.355.206-1.37.507-1.682 1.944-2.013a23.43 23.43 0 0 1 2.757-.474c.802.026 1.234.442 1.294 1.25zM2.702 4.125h17.194M16.985.723l2.942 3.613-2.942 2.785",
    fill: "none",
    stroke: "#FFF"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgWithdraw);
var _default = exports["default"] = Memo;